module.exports = "<footer>\r\n  <div class=\"container\">\r\n    <a class=\"logo-font\" routerLink=\"/\">conduit</a>\r\n    <span class=\"attribution\">\r\n      &copy; {{ today | date: 'yyyy' }}.\r\n      An interactive learning project from <a href=\"https://thinkster.io\">Thinkster</a>.\r\n      Code licensed under MIT.\r\n    </span>\r\n  </div>\r\n</footer>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/layout/footer.component.html
// module id = ./src/app/shared/layout/footer.component.html
// module chunks = main